export function attachTapListener(
  canvas: HTMLCanvasElement,
  onTap: (x: number, y: number) => void,
): void {
  let startX = 0;
  let startY = 0;
  let startMs = 0;

  canvas.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    const rect = canvas.getBoundingClientRect();
    startX = e.clientX - rect.left;
    startY = e.clientY - rect.top;
    startMs = performance.now();
  }, { passive: false });

  canvas.addEventListener('pointerup', (e) => {
    e.preventDefault();
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const dx = x - startX;
    const dy = y - startY;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const elapsed = performance.now() - startMs;
    if (dist < 12 && elapsed < 600) {
      onTap(x, y);
    }
  }, { passive: false });

  canvas.addEventListener('pointercancel', () => { startMs = 0; });
}
